import { createAction, props } from '@ngrx/store';

import { FetchEnumsResponse } from './enums.types';

export const enumsFetchListStart = createAction('ENUM/FETCH_LIST_START');
export const enumsFetchListSuccess = createAction('ENUM/FETCH_LIST_SUCCESS', props<{ payload: FetchEnumsResponse }>());
export const enumsFetchListFail = createAction('ENUM/FETCH_LIST_FAIL');
